import {
  DeepResearchStage,
  DeepResearchTasksStatus,
} from '@/modules/AgenticChat/models/DeepResearch';
import { z } from 'zod';

// new deep research schema with research plan and execution plan

export const AGENTIC_CHAT_DEEP_RESEARCH_EVENT_DATA_SCHEMA = z.discriminatedUnion('stage', [
  z.object({
    research_id: z.string().optional(),
    stage: z.literal(DeepResearchStage.CLARIFICATION),
    content: z.string().optional(),
    type: z.string().optional(),
  }),
  z.object({
    research_id: z.string().optional(),
    stage: z.literal(DeepResearchStage.PLANNING),
    plan: z.array(z.object({ task_id: z.string(), content: z.string() })).optional(),
    title: z.string().optional(),
    type: z.string().optional(),
  }),
  z.object({
    research_id: z.string().optional(),
    stage: z.literal(DeepResearchStage.EXECUTION),
    type: z.string().optional(),
    task_id: z.string().optional(),
    task_status: z.enum(Object.values(DeepResearchTasksStatus) as [string, ...string[]]).optional(),
    tool_name: z.string().optional(),
    capability: z.string().optional(),
    tool_call_id: z.string().optional(),
    args_json: z.string().optional(),
  }),
  z.object({
    research_id: z.string().optional(),
    stage: z.literal(DeepResearchStage.GENERATION),
    type: z.string().optional(),
    content: z.string().optional(),
  }),
]);
